import styled from 'styled-components';

// 메인메뉴 패널 하단 여백. 패널 패딩 대신 콘텐츠 요소로 두어, 바닥에 펼친 하위메뉴가 올 때는
// 렌더하지 않아 하위메뉴가 패널 아래까지 닿도록 한다.
export const BottomSpace = styled.div`
  height: 1rem;
`;
